import { buildQueryKey } from '@webapp/core/utils/react-query/buildQueryKey'
import { resolveReviseFormDefaultsUseCase } from '../business-logic/use-cases/ResolveReviseFormDefaults'
import { expenseRepository } from '../data-access/repositories/ExpenseRepository'

const base = ['expense-report']

export const expenseReportQueryConfig = {
  detail: (uuid: string) => ({
    queryKey: buildQueryKey([...base, uuid]),
    queryFn: () => expenseRepository.getByUuid(uuid),
  }),
  reviseFormDefaults: (locationId: number, departmentId: number) => ({
    queryKey: buildQueryKey([
      ...base,
      'revise-form-defaults',
      locationId,
      departmentId,
    ]),
    queryFn: () =>
      resolveReviseFormDefaultsUseCase.execute({ locationId, departmentId }),
  }),
  budgetCheck: (expenseId: number, nextApproverId?: Nullable<number>) => ({
    queryKey: buildQueryKey([
      ...base,
      expenseId,
      'budget-check',
      nextApproverId,
    ]),
    queryFn: () =>
      expenseRepository.checkBudget(expenseId, nextApproverId ?? null),
  }),
  lineItemFormData: (userId: number) => ({
    queryKey: buildQueryKey([...base, 'line-item-form-data', userId]),
  }),
  getBudgetCategories: ({
    expenseUuid,
    expenseId,
  }: {
    expenseUuid: string
    expenseId: number
  }) => ({
    queryKey: buildQueryKey([...base, expenseUuid, 'budget-categories']),
    queryFn: () => expenseRepository.getBudgetCategories(expenseId),
  }),
  getSpendBySecondaryCategory: ({
    expenseUuid,
    expenseId,
    secondaryCategoryId,
    startDate,
    endDate,
  }: {
    expenseUuid: string
    expenseId?: number
    secondaryCategoryId?: number
    startDate?: string
    endDate?: string
  }) => ({
    queryKey: buildQueryKey([
      ...base,
      expenseUuid,
      'spend-by-secondary-category',
      secondaryCategoryId,
      startDate,
      endDate,
    ]),
    queryFn: () => {
      if (!secondaryCategoryId || !expenseId || !startDate || !endDate) {
        throw new Error(
          'Missing required parameters for getSpendBySecondaryCategory query. Ensure secondaryCategoryId, expenseId, startDate, and endDate are all defined.'
        )
      }
      return expenseRepository.getSpendBySecondaryCategory(
        secondaryCategoryId,
        expenseId,
        startDate,
        endDate
      )
    },
  }),
}
